/// <reference types="vite/client" />

function isSelectionDebugEnabled(): boolean {
  return Boolean(import.meta.env?.DEV);
}

export function debugSelection(
  title: string,
  details: () => Record<string, unknown>,
): void {
  if (!isSelectionDebugEnabled()) return;

  console.groupCollapsed(`[mymaps:selection] ${title}`);
  console.log(details());
  console.groupEnd();
}
